module.exports = __webpack_public_path__ + "assets/img/1ca5-sx.svg";